import { render } from "./Cursor.vue?vue&type=template&id=1705b4aa&scoped=true&ts=true"
import script from "./Cursor.vue?vue&type=script&lang=ts"
export * from "./Cursor.vue?vue&type=script&lang=ts"

import "./Cursor.vue?vue&type=style&index=0&id=1705b4aa&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1705b4aa"]])

export default __exports__